import {countriesInfosAndCurrencyMock$, CountryInfosAndCurrencyModel} from '../mocks/countries-infos-and-currency-mock';
import * as _ from 'lodash';
import {RewardModel} from '../../core-logic/models/business/sub/reward/reward-model';
import {SliderOptionTypeList} from '../enums/slider-option-type-list';
import {ModalMessageType} from '../../core-logic/models/custom-modal/custom-modal-model';
import {OptionsTypeList} from '../enums/options-type-list';

export function getCountryByName(countryName: string): CountryInfosAndCurrencyModel {
    return countriesInfosAndCurrencyMock$.find((country) => {
        return _.toLower(country.french_name)  === _.toLower(countryName);
    });
}

export function getCountryByAlpha2(alpha2: string): CountryInfosAndCurrencyModel {
    return countriesInfosAndCurrencyMock$.find((country) => {
        return _.toLower(country.alpha2) === _.toLower(alpha2);
    });
}

export function getCountryByCallSign(callSign: number): CountryInfosAndCurrencyModel {
    return countriesInfosAndCurrencyMock$.find((country) => {
        return country.call_sign === callSign;
    });
}

export function isErrorModel(someObject: any): boolean {
    return someObject.hasOwnProperty('code') && someObject.hasOwnProperty('message');
}

 export const isPermissionStatus = (someObject: any): boolean => {
  return someObject.hasOwnProperty('location') && someObject.hasOwnProperty('coarseLocation');
}

export function getFileReader(): FileReader {
    const fileReader = new FileReader();
    const zoneOriginalInstance = (fileReader as any).__zone_symbol__originalInstance;
    return zoneOriginalInstance || fileReader;
}

export function dataURItoBlob(imageDataURI: string): Blob {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(imageDataURI.split(',')[1]);
    // separate out the mime component
    const mimeString = imageDataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);
    // create a view into the buffer
    const ia = new Uint8Array(ab);
    // set the bytes of the buffer to the correct values
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    // write the ArrayBuffer to a blob, and you're done
    return new Blob([ab], {type: mimeString});
}

export function sortRewards(rewards: RewardModel []): RewardModel [] {
  return rewards.sort((firstReward, secondReward) => {
    return firstReward.value - secondReward.value;
  });
}

export function formatDistance(distance: number): string {
  if (distance >= 1000) {
    return `${_.floor(distance / 1000, 2)} km`;
  }
  return `${_.floor(distance, 2)} m`;
}

export function makeAddOptionModal(optionType: SliderOptionTypeList) {
  function getOptionName(optionType: SliderOptionTypeList): string {
    switch (optionType) {
      case SliderOptionTypeList.REWARD:
        return 'une récompense';
      case SliderOptionTypeList.MEMBER:
        return 'un membre';
      case SliderOptionTypeList.TAG:
        return 'un badge';
      case SliderOptionTypeList.PROMOTION:
        return 'une actualité';
      case SliderOptionTypeList.SPONSORSHIP:
        return 'le parrainage de clients';
    }
  }
  return {
    title: 'Recharge ton porte-monnaie',
    message: {
      value:
        '<div class="ion-text-center">' +
        `Ton porte monnaie est vide, recharge le pour ajouter ${getOptionName(optionType)}.` +
        '<img src="assets/icons/empty-wallet.webp" alt="empty wallet">' +
        '</div>',
      type: ModalMessageType.HTML
    },
    customizer: {color: '#1D1D1D'},
    validate_button: {label: 'Continuer'},
    cancel_button: {visible: false}
  };
}

export const floorAndRound = (number: number): number => _.round(number, 2);

export const toCompletedAmountByZeroFormat = (number: number ): string => {
  const floored = floorAndRound(number);
  const numberAsString = floored.toString(10);
  if (numberAsString.split('.')[1]) {
    if (numberAsString.split('.')[1].length === 1) {
      return numberAsString + '0';
    }
    return numberAsString;
  }
  return numberAsString + '.00';
}

/*export const animateNumber = (value: number): Observable<number> => {
  const i = 0;
  return interval(500).pipe(() => of(value));
}*/

export const toOptionTypeList = (optionType: SliderOptionTypeList | 'WHEEL_GAME'): OptionsTypeList => {
  switch (optionType) {
    case SliderOptionTypeList.REWARD:
      return OptionsTypeList.REWARD;
    case SliderOptionTypeList.MEMBER:
      return OptionsTypeList.MEMBER;
    case SliderOptionTypeList.TAG:
      return OptionsTypeList.TAG;
    case SliderOptionTypeList.PROMOTION:
      return OptionsTypeList.PROMOTION;
    case SliderOptionTypeList.SPONSORSHIP:
      return OptionsTypeList.SPONSORSHIP;
    case 'WHEEL_GAME':
      return OptionsTypeList.WHEEL_GAME;
  }
}

export const initStampValues = (limit: number = 1000): number [] => {
  const stampValues: number [] = [];
  for (let stampValue = 1; stampValue <= limit; stampValue++) {
    if ((stampValue < 100 && stampValue%5 === 0) || (stampValue >= 100 && stampValue%10 === 0)) { stampValues.push(stampValue); }
  }
  return stampValues;
}
